<script>
import moment from "moment";
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";
import Loader from "../../components/shared/Loader/Loader.vue";
import Modal from "../../components/shared/Modal/Modal.vue";
import Pagination, {
  PER_PAGE,
} from "../../components/shared/Table/Pagination.vue";
import Table from "../../components/shared/Table/Table.vue";
import CustomInputWithImg from "../../components/shared/UI/CustomInputWithImg.vue";
import { DataService } from "../../config/dataService";
import store from "../../vuex/store";
import BillingForm from "../Billing/BillingForm.vue";
import EditKnowledgeForm from "./EditKnowledgeForm.vue";
const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
const STATUS_POLLING_FREQUENCY = 0.45 * 60 * 1000;

let intervalId = null;

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    dataType: {
      type: String,
      required: true,
    },
  },
  components: {
    Loader,
    ButtonWithLoadWebsite,
    Modal,
    CustomInputWithImg,
    EditKnowledgeForm,
    Pagination,
    Table,
    BillingForm,
  },
  data() {
    return {
      billingModalShown: false,
      linkData: [],
      processedLinks: [],
      linksSkip: 0,
      visibleLinksLength: PER_PAGE,
      showModal: false,
      isEditHistoryModalOpen: false,
      modalType: "",
      websiteLink: "",
      editedLink: null,
      editedLinkKnowledge: [],
      knowledgeSkip: 0,
      visibleKnowledgeLength: PER_PAGE,
      text: "",
      routes: {
        LINKS: "links",
        GOOGLE: "google",
        TEXT: "text",
      },
      minLength: 50,
      maxLength: 1500,
      pickerApiLoaded: false,
      gapiInited: false,
      gisInited: false,
      isDataLoading: false
    };
  },
  computed: {
    isLoading() {
      return store.getters.isLoading;
    },
    isSubscriptionChecked() {
      const subscriptionStatus = this.chosenWidget?.owner?.subscription
        ? this.chosenWidget?.owner?.subscription?.status
        : this.chosenWidget?.owner?.subscription;

      if (
        !subscriptionStatus ||
        (subscriptionStatus !== "active" && subscriptionStatus !== "trialing")
      ) {
        let linksCount = 0;

        for (const item of this.linkData) {
          if (item.status !== "unsubscribed") {
            linksCount++;

            if (linksCount === 10) {
              break;
            }
          }
        }

        return linksCount < 10;
      } else {
        return true;
      }
    },

    totalLinksCount() {
      return this.linkData.length;
    },

    totalLinksDetails() {
      const successCount = this.linkData.filter(i => i.status === 'success').length;
      const subLinks = this.chosenWidget?.owner?.subscription?.links_available;
      return `(Chatbot trained on ${successCount} of ${subLinks || 10} links)`;
    },

    chosenWidget() {
      return store.state.users.chosenWidget;
    },

    knowledgePaginationVisible() {
      return Math.ceil(this.editedLinkKnowledge.length / PER_PAGE) > 1;
    },

    isLinkProcessingOrPendingIdArray() {
      const processedLinksIdArray = this.linkData
        .filter(
          (link) => link.status === "processing" || link.status === "pending"
        )
        .map((link) => link.id);

      return processedLinksIdArray;
    },

    visibleLinks() {
      return this.linkData.slice(this.linksSkip, this.visibleLinksLength);
    },

    visibleKnowledge() {
      return this.editedLinkKnowledge.slice(
        this.knowledgeSkip,
        this.visibleKnowledgeLength
      );
    },

    routeName() {
      return this.$route.name;
    },
  },

  watch: {
    chosenWidget: {
      handler: "firstLinkDataLoad",
      immediate: true,
      deep: true,
    },

    dataType: {
      handler: "firstLinkDataLoad",
      immediate: true,
    },

    isLinkProcessingOrPendingIdArray: {
      handler: "startLinkStatusTracking",
      immediate: true,
    },
  },

  methods: {
    toggleBillingModal() {
      this.billingModalShown = !this.billingModalShown;
    },

    getTimeFromLastTraining(date) {
      return moment(new Date(date)).fromNow();
    },

    setLinkStatus(id, status, finished) {
      this.linkData.map((link) => {
        if (link.id !== id) {
          return;
        }

        link.status = status;
        link.finishedAt = finished;
      });
    },

    handleAddClick() {
      this.$emit("addClick");
    },

    async retrain(link) {
      store.dispatch("startLoading");

      if (this.routeName === this.routes.GOOGLE) {
        this.handleLinkClick(link);
      } else {
        try {
          await DataService.post(
            `${API_ENDPOINT}scrapper/history/retrain/${link.id}`,
            {},
            { widgetId: this.chosenWidget?.id }
          );
          this.setLinkStatus(link.id, "processing");
          this.processedLinks = [...this.processedLinks, link];
        } catch (error) {
          console.error(error);
          const errorMessage = error?.response?.data?.errorDescription === 'Access is denied. Contact support'
            ? 'To retrain link you need to upgrade your tariff plan'
            : error?.response?.data?.errorDescription || "Link add error";
          this.$toast.error(errorMessage);
        } finally {
          store.dispatch("endLoading");
        }
      }
    },

    async firstLinkDataLoad() {
      this.linksSkip = 0;
      this.visibleLinksLength = PER_PAGE;
      this.knowledgeSkip = 0;
      this.visibleKnowledgeLength = PER_PAGE;

      // if (!this.chosenWidget) {
      //   this.$router.push({ path: "/user/dashboard" });
      // }

      try {
        if (this.chosenWidget) {
          const { data } = await this.getLinkData();
          this.linkData = data;
        }
      } catch (error) {
        this.$router.push({ path: "/user/dashboard" });
        console.log(
          "🚀 ~ file: DataPage.vue:193 ~ firstLinkDataLoad ~ error:",
          error
        );
      }
    },

    async getLinkData() {
      this.isDataLoading = true;
      try {
        if (this.chosenWidget) {
          return await DataService.post(
            `${API_ENDPOINT}scrapper/allHistoryByType/${this.chosenWidget?.id}`,
            { type: this.$props?.dataType }
          );
        }
      } catch (error) {
        console.error(error);
        this.$toast.error(
          error?.response?.data?.errorDescription || "Get link data error"
        );
      } finally {
        this.isDataLoading = false;
      }
    },

    handleVisibleLinksUpdate({ skip, length }) {
      this.linksSkip = skip;
      this.visibleLinksLength = length;
    },

    handleVisibleKnowledgeUpdate({ skip, length }) {
      this.knowledgeSkip = skip;
      this.visibleKnowledgeLength = length;
    },

    startLinkStatusTracking() {
      if (intervalId) return;

      intervalId = setInterval(async () => {
        if (this.isLinkProcessingOrPendingIdArray.length === 0) {
          clearInterval(intervalId);
          intervalId = null;
          return;
        }

        const { data: newProcessedLinks } = await DataService.post(
          `${API_ENDPOINT}scrapper/historyStatusArray`,
          this.isLinkProcessingOrPendingIdArray
        );

        newProcessedLinks.map((link) =>
          this.setLinkStatus(link?.id, link?.status, link?.finishedAt)
        );

        if (this.isLinkProcessingOrPendingIdArray.length === 0) {
          clearInterval(intervalId);
          intervalId = null;
        }
      }, STATUS_POLLING_FREQUENCY);
    },

    handleLinkHover(url) {
      this.hoverLinkUrl = url;
    },

    async handleLinkClick(link) {
      const data = await this.getLinkHistory(link?.id);
      if (!data) return;

      this.editedLinkKnowledge = data;
      this.isEditHistoryModalOpen = true;
      this.editedLink = link;
    },

    async updateChosenWidget() {
      try {
        this.isDataLoading = true;
        const result = await DataService.get(
          `${API_ENDPOINT}widget/get-by-id/${this.chosenWidget?.id}`
        );

        store.dispatch("setChosen", result?.data);
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.errorDescription ||
          "Update chosen widget error"
        );
      } finally {
        this.isDataLoading = false;
      }
    },

    async handleLinkDelete(linkId) {
      store.dispatch("startLoading");

      try {
        const response = await DataService.delete(
          `${API_ENDPOINT}scrapper/history/delete/${linkId}`
        );

        if (response?.status === 200) {
          await this.updateChosenWidget(this.chosenWidget?.id);

          this.$toast.warning("Link successfully deleted");
        }
      } catch (error) {
        console.error(error);

        this.$toast.error(
          error?.response?.data?.errorDescription || "Delete error"
        );
      } finally {
        store.dispatch("endLoading");
      }
    },

    handleUpgradeClick() {
      this.$router.push("/user/billing");
    },

    async getLinkHistory(sourceId) {
      store.dispatch("startLoading");

      try {
        const result = await DataService.get(
          `${API_ENDPOINT}knowledge/getKnowledgeBySourceId/${sourceId}`
        );

        if (!result?.data || !result.data?.length) {
          this.$toast.error(
            "Link history is empty"
          );
          return null;
        }

        return result?.data;
      } catch (error) {
        console.error(error);
        this.$toast.error(
          error?.response?.data?.errorDescription || "Get link history error"
        );
      } finally {
        store.dispatch("endLoading");
      }
    },

    async updateKnowledge(knowledge) {
      store.dispatch("startLoading");
      try {
        if (this.chosenWidget) {
          const response = await DataService.patch(
            `${API_ENDPOINT}knowledge/updateKnowledge/${knowledge?.id}`,
            {
              widgetId: `${this.chosenWidget?.id}`,
              data: knowledge?.data,
            }
          );

          if (response?.status === 200) {
            const updatedKnowledgeIdx = this.editedLinkKnowledge.findIndex(
              (item) => item?.id === knowledge?.id
            );
            this.editedLinkKnowledge[updatedKnowledgeIdx].data =
              knowledge?.data;
            this.editedLinkKnowledge[updatedKnowledgeIdx].updatedAt = new Date(
              Date.now()
            ).toISOString();

            this.setLinkStatus(
              this.editedLink?.id,
              "success",
              this.editedLink?.finishedAt
            );
          }
        }
      } catch (error) {
        console.error(error);
        this.$toast.error(
          error?.response?.data?.errorDescription || "Update knowledge error"
        );
      } finally {
        store.dispatch("endLoading");
      }
    },

    async deleteKnowledge(knowledgeId) {
      try {
        const response = await DataService.delete(
          `${API_ENDPOINT}knowledge/deleteKnowledge/${knowledgeId}`
        );

        if (response?.status === 200) {
          this.editedLinkKnowledge = this.editedLinkKnowledge.filter(
            ({ id }) => id !== knowledgeId
          );
          this.$toast.warning("Knowledge successfully deleted!");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },

  beforeDestroy() {
    clearInterval(intervalId);
    intervalId = null;
  },
};
</script>

<template>
  <div>
    <Table :title="$props.title" :items="visibleLinks" :total-items-count="totalLinksCount" :total-items-details="totalLinksDetails" :is-loading="isLoading"
      @updateVisible="handleVisibleLinksUpdate" @addClick="handleAddClick" @itemClick="handleLinkClick"
      @retrainClick="retrain" @deleteClick="handleLinkDelete" @upgradeClick="handleUpgradeClick" />

    <Modal :isModalOpen="billingModalShown" @close="billingModalShown = false">
      <div slot="body" class="modal_body">
        <BillingForm type="modal" />
      </div>
    </Modal>

    <Modal :isModalOpen="isEditHistoryModalOpen" @close="isEditHistoryModalOpen = false">
      <div slot="body" v-if="editedLinkKnowledge.length > 0" class="modal_body">
        <h5 class="add_link_title">Edit Knowledge</h5>

        <a v-if="routeName !== routes.TEXT" class="edit_link_title" target="_blank" rel="noopener noreferrer nofollow"
          :href="editedLink.source">{{
            editedLink.source.length > 65
            ? `${editedLink.source.slice(0, 62)}...`
            : editedLink.source
          }}</a>

        <p class="edit_link_text_title" v-if="routeName === routes.TEXT">
          {{
            editedLink.source.length > 65
            ? `${editedLink.source.slice(0, 62)}...`
            : editedLink.source
          }}
        </p>

        <div class="modal_pagination_box" v-if="knowledgePaginationVisible">
          <Pagination @updateVisibleData="handleVisibleKnowledgeUpdate" :allDataLength="editedLinkKnowledge.length" />
        </div>

        <ul class="knowledge_list">
          <li class="knowledge_item" v-for="(knowledge, index) of visibleKnowledge">
            <EditKnowledgeForm :knowledge="knowledge" :updateKnowledge="updateKnowledge"
              @deleteKnowledge="deleteKnowledge" />
          </li>
        </ul>
      </div>
    </Modal>
    <Loader :loading="isDataLoading" />
  </div>
</template>

<style scoped>
.add_link_title {
  color: #4f4f4f;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 32px;

  @media screen and (max-width: 1024px) {
    margin-bottom: 8px;
  }
}

.edit_link_title {
  color: #4f4f4f;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  margin-bottom: 32px;
  transition: all ease-in-out 300ms;
  display: block;
  width: 100%;
  overflow-wrap: break-word;

  @media screen and (max-width: 1024px) {
    margin-bottom: 8px;
  }

  &:hover {
    cursor: pointer;
    text-decoration: none;
    color: #3056d3;
  }
}

.edit_link_text_title {
  color: #4f4f4f;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  margin-bottom: 32px;
  display: block;
  width: 100%;
  overflow-wrap: break-word;

  @media screen and (max-width: 1024px) {
    margin-bottom: 8px;
  }
}

.modal_pagination_box {
  margin: 16px 0 32px;
  display: flex;
  justify-content: flex-end;

  @media screen and (max-width: 1024px) {
    margin: 16px 0;
    justify-content: center;
  }
}

.knowledge_list {
  padding: 0 16px 0 0;
  margin: 0;
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 64px;
  flex-grow: 1;
}

.knowledge_item {
  list-style: none;
}

.modal_body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-width: 600px;
}
</style>
